import { ComponentIds, HierarchyUtils, } from "@inter-ikea-core/core";
import { SystemBase2 } from "@inter-ikea-core/core-toolbox";
import { createInteractableViewerObject, handleViewerObjectOnRedo, handleViewerObjectOnUndo, isSectionType, updateViewerObject, } from "../functions/interactableViewerObjectHandler";
export class InteractableSectionSystem extends SystemBase2 {
    constructor(core, appId) {
        super(ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID, ComponentIds.UPDATED_FROM_SNAPSHOT_EVENT_COMPONENT_ID);
        this.core = core;
        this.appId = appId;
        this.doingChangesOnComponent = [];
        this.id = "InteractableSectionSystem";
        this.viewerObejctName = "invisible-viewer-object";
        this.viewerObjectConnector = "viewer-object-connector";
        this.getExistingEntitiesOnSameConnector = (entity) => {
            var _a, _b;
            const guestConnections = (_a = entity.getComponent(ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID)) === null || _a === void 0 ? void 0 : _a.connections;
            const currentEntityHostConnector = (_b = guestConnections === null || guestConnections === void 0 ? void 0 : guestConnections.find((connection) => connection.hostConnector.key.includes(this.viewerObjectConnector))) === null || _b === void 0 ? void 0 : _b.hostConnector;
            const parentEntity = HierarchyUtils.parent(entity);
            if (!parentEntity)
                return;
            const childEntites = HierarchyUtils.children(parentEntity);
            const matchingEntites = childEntites.filter((entity) => {
                var _a;
                const connections = (_a = entity.getComponent(ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID)) === null || _a === void 0 ? void 0 : _a.connections;
                return connections === null || connections === void 0 ? void 0 : connections.find((connection) => connection.hostConnector.key === (currentEntityHostConnector === null || currentEntityHostConnector === void 0 ? void 0 : currentEntityHostConnector.key));
            });
            return matchingEntites;
        };
        this.getExistingViewerObjectEntities = (entity) => {
            const childEntites = HierarchyUtils.children(entity);
            return childEntites.filter((entity) => {
                var _a;
                return (_a = entity
                    .getComponent(ComponentIds.PRODUCT_COMPONENT_ID)) === null || _a === void 0 ? void 0 : _a.productRef.includes(this.viewerObejctName);
            });
        };
        this.systemsAfterMe = null;
        this.systemsBeforeMe = null;
    }
    /**
     * When adding a section to the scene, a clickable ViewerObject will be created and attached to the section
     * @param _entity
     * @param _newComponent
     */
    onAddComponent(_entity, _newComponent) {
        var _a;
        const productRef = (_a = _entity.getComponent(ComponentIds.PRODUCT_COMPONENT_ID)) === null || _a === void 0 ? void 0 : _a.productRef;
        if (isSectionType(_entity, this.core, this.appId)) {
            createInteractableViewerObject(_entity, this.core, this.viewerObejctName);
        }
        else if (productRef === null || productRef === void 0 ? void 0 : productRef.includes(this.viewerObejctName)) {
            const existingEntities = this.getExistingEntitiesOnSameConnector(_entity);
            if (existingEntities && existingEntities.length > 1) {
                _entity.dispose();
            }
            else {
                updateViewerObject(_entity, this.core);
            }
        }
    }
    /**
     * Core doesn't handle ViewerObjects on undo/redo
     * Here the viewerObject will be removed on undo and re-added on redo
     * @param _entity
     * @param _newComponent
     * @returns
     */
    onAddComponent2(_entity, _newComponent) {
        const productComponent = _entity.getComponent(ComponentIds.PRODUCT_COMPONENT_ID);
        if ((productComponent === null || productComponent === void 0 ? void 0 : productComponent.productRef) !== this.viewerObejctName)
            return;
        const entityAfterLoadingSnapshot = _newComponent.entity;
        const stateBeforeLoadingSnapshot = _newComponent.entityStateBeforeLoadingSnapshot;
        if (!entityAfterLoadingSnapshot && stateBeforeLoadingSnapshot) {
            handleViewerObjectOnUndo(stateBeforeLoadingSnapshot);
        }
        else if (entityAfterLoadingSnapshot && !stateBeforeLoadingSnapshot) {
            handleViewerObjectOnRedo(_entity, this.core, this.appId);
        }
    }
}
